import { useMemo } from "react";
import { useSelector } from "react-redux";

import UserTable from "./components/UserTable";
import CompleteProfileBanner from "@/features/home/components/CompleteProfileBanner";
import CompleteProfileTypesBanner from "@/features/home/components/CompleteProfileTypesBanner";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { Roles } from "@/shared/utils/constants";

const UserList = () => {
  const currentUser = useSelector(selectCurrentUser);

  const tableDetails = useMemo(() => {
    if (!currentUser) return;

    const columns = [
      "fullName",
      "email",
      "organization",
      "jobTitle",
      "communityRoles",
      "expertiseAreas",
      "profileType",
    ];
    const filters = [
      "search",
      "organizations",
      "countries",
      "achievements",
      "communityRoles",
      "expertiseAreas",
      "department",
      "jobTitle",
      "profileTypes",
    ];

    if (currentUser.role === Roles.ADMIN.value) {
      columns.push("actions");
    }

    return {
      columns,
      filters,
      defaultFilters: {
        role: Roles.USER.value,
      },
    };
  }, [currentUser]);

  return (
    <div className="flex flex-col gap-200">
      <div className="flex gap-200">
        <CompleteProfileBanner />
        <CompleteProfileTypesBanner />
      </div>
      {tableDetails && (
        <UserTable
          columnNames={tableDetails.columns}
          filterNames={tableDetails.filters}
          defaultFilters={tableDetails.defaultFilters}
        />
      )}
    </div>
  );
};

export default UserList;
